import { pipelineMapWidget as pipelineMapWidgetImpl } from '../widgets/pipeline-map-widget';
import type { DeepDiveWidget } from '@/core/widgets/export';

export { PipelineAlertScrollerWidget } from '../widgets/pipeline-notification-widget';
export const pipelineMapWidget: DeepDiveWidget = pipelineMapWidgetImpl;
